<template>
    <div>
        <Header @show-contact="showContact" :title="'合作咨询'"></Header>
        <div class="contacts-m">
            <h1>合作咨询</h1>
            <p>请填写详细诉求以便于我们更快的与您联系<br>或直接拨打13269322718联系我们</p>
        </div>
        <div class="labels-m">
            <div class="form-item-m">
                <label><span class="required">*</span>联系人</label>
                <input v-model="form.contactName" placeholder="请填写联系人姓名">
            </div>
            <div class="form-item-m">
                <label><span class="required">*</span>电话</label>
                <input v-model="form.contactNumber" placeholder="请填写联系人电话">
            </div>
            <div class="form-item-m">
                <label><span class="required">*</span>邮箱</label>
                <input v-model="form.contactEmail" placeholder="请填写联系人邮箱">
            </div>
            <div class="form-item-m">
                <label><span class="required">*</span>公司/单位</label>
                <input v-model="form.workPlace" placeholder="请填写合作公司/单位">
            </div>
            <div class="form-item-m last">
                <label><span class="required">*</span>合作意向</label>
                <textarea v-model="form.contactRemark" placeholder="请告诉我们您的合作意向，以便我们将为您提供最优方案…"></textarea>
            </div>
        </div>
        <div class="submit-m" @click="submitForm()">完成</div>
        <Footer></Footer>
    </div>
</template>
<script>
import { addContact } from '../api/contact';
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
export default {
    data() {
        return {
            form: {
                contactName: '',
                contactNumber: '',
                contactEmail: '',
                workPlace: '',
                contactRemark: ''
            }
        }
    },
    components: {
        Footer,
        Header
    },
    methods: {
        validateMobile(mobile) {
            var mobileRegex = /^[1][3,4,5,7,8][0-9]{9}$/;
            return mobileRegex.test(mobile);
        },
        validateEmail(email) {
            var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            return emailRegex.test(email);
        },
        async submitForm() {
            if (!this.form.contactName || !this.form.contactNumber || !this.form.contactEmail || !this.form.workPlace || !this.form.contactRemark) {
                alert("请填写所有必填项")
                return;
            }
            if (!this.validateMobile(this.form.contactNumber)) {
                alert("请填写正确的联系人电话");
                return;
            }
            if (!this.validateEmail(this.form.contactEmail)) {
                alert("请填写正确的联系人邮箱");
                return;
            }
            const { data } = await addContact(this.form);
            if (data == 1) {
                alert("合作之桥已搭建，意向递交成功！")
                this.form = {};
                this.$emit('close', true); 
            } else {
                alert("信息提交异常，请刷新页面重试~")
            }
        }
    }
}
</script>
<style scoped>
@import '../assets/css/contactStyle.css';
</style>